import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import ResetPasswordForm from "../components/forms/ResetPasswordForm"
import {
  resetPasswordForUser,
  validateResetPasswordToken
} from "../actions/authActions"
import {withTranslation} from "react-i18next"

class ResetPasswordView extends Component {
  state = {
    loading: true,
    success: false
  }

  componentDidMount() {
    this.props
      .validateResetPasswordToken({
        reset_password_token: this.props.match.params.reset_password_token,
        redirect_url: "OK"
      })
      .then(() => this.setState({loading: false, success: true}))
      .catch(() => this.setState({loading: false, success: false}))
  }

  render() {
    const {loading, success} = this.state
    const token = this.props.match.params.reset_password_token

    if (loading) {
      return (
        <div>
          <p className="sh-text-content forgot-password">
            {this.props.t("resetPassword.validating")}
          </p>
        </div>
      )
    }
    return (
      <div>
        {success ? (
          <ResetPasswordForm token={token} history={this.props.history} />
        ) : (
          <p className="sh-text-content forgot-password">
            {this.props.t("resetPassword.invalid")}
          </p>
        )}
      </div>
    )
  }
}

ResetPasswordView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      reset_password_token: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  t: PropTypes.func.isRequired
}

export default withTranslation()(
  connect(null, {
    resetPasswordForUser,
    validateResetPasswordToken
  })(ResetPasswordView)
)



// WEBPACK FOOTER //
// ./src/views/ResetPasswordView.js